import {useQuery} from 'react-query';
import {client, logout} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';

const getLoyaltySummary = (urls: any, field: string, value: string, domain: string, deviceCode: string) => {
	return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/snippets/loyaltysummary?field=${encodeURIComponent(field)}&value=${encodeURIComponent(value)}`);
}

export default function useGetLoyaltySummary(urls: any, field: string, value: string, domain: string, deviceCode: string) {
	const {status, data, error, isFetching, refetch} = useQuery(['LoyaltySummary', field, value], () => getLoyaltySummary(mapServiceUrls(urls), field, value, domain, deviceCode), {enabled: false, staleTime: 0});
	const summary = data ? data.data : undefined;
	// @ts-ignore
	if (error === 'Expired key')
		logout();

	return {status, summary, error, isFetching, refetch};
}
